import { z } from 'zod'

const itemId = z.string().min(1).max(200)
const base64Url = z
  .string()
  .min(1)
  .max(256)
  .regex(/^[A-Za-z0-9_-]+=*$/)

export const inboxSeenSchema = z.object({ ids: z.array(itemId).min(1).max(200) }).strict()
export type InboxSeenInput = z.infer<typeof inboxSeenSchema>

export const pushSubscriptionSchema = z
  .object({
    endpoint: z.url({ protocol: /^https$/ }).max(2048),
    keys: z.object({ p256dh: base64Url, auth: base64Url }).strict(),
  })
  .strict()
export type PushSubscriptionInput = z.infer<typeof pushSubscriptionSchema>

export const pushUnsubscribeSchema = z
  .object({ endpoint: z.url({ protocol: /^https$/ }).max(2048) })
  .strict()

export interface InboxNewItem {
  id: string
  title: string
  href: string
  appearedAt: string
}

export interface InboxState {
  /** Items in the person's queue they have not opened yet, newest first. */
  items: InboxNewItem[]
  /** The VAPID public key, or null when phone push is not configured on the server. */
  pushKey: string | null
}
